import * as z from 'zod';

export const formSchema = z.object({
  type: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;
